import { reduce as _reduce } from 'lodash';
import { uuidv4 } from '@graphistry/node-util/uuid';
import { ref as $ref } from '@graphistry/falcor-json-graph';
import { getDefaultQueryForDataType } from '@graphistry/viz/src/models/expressions';

const logger = require('@graphistry/logger')(module);

export function search(view) {
    return {
        search: {
            searchTerm: "Hello, World!"
        },
        searches: {
            length: 0,
            visible: true,
            id: 'searches',
            name: 'Searches',
            templates: $ref(`${view}.columns`),
            controls: [
                {
                    selected: true,
                    id: 'toggle-searches',
                    name: 'Searches',
                    items: $ref(`${view}.searches`)
                }
            ]
        }
    };
}

export function createSearchExpression(term) {
    return {
        ...expression(props),
        expressionType: 'filter'
    };
}
